import React from "react";
import "./RecipientTypeSelector.css";

const RecipientTypeSelector = ({ selectedType, onTypeChange, showBankOption, disableSendToPhone, interfaceMode }) => {
  // Handle three interface modes: P2POnly, FedNowDirectOnly, Both
  if (interfaceMode === 'P2POnly' || !showBankOption) {
    // P2POnly mode: no selector needed, always use phone_email
    return null;
  }

  if (interfaceMode === 'FedNowDirectOnly') {
    // FedNowDirectOnly mode: no selector needed, always use bank_account
    return null;
  }

  // Both mode: show selector with both options
  return (
    <div className="recipient-type-selector">
      <label className="recipient-type-label">Recipient Type</label>
      <div className="recipient-type-buttons">
        <button
          type="button"
          className={`recipient-type-btn ${selectedType === "phone_email" ? "active" : ""}`}
          onClick={() => onTypeChange("phone_email")}
        >
          {disableSendToPhone ? "Email" : "Phone or email"}
        </button>
        <button
          type="button"
          className={`recipient-type-btn ${selectedType === "bank_account" ? "active" : ""}`}
          onClick={() => onTypeChange("bank_account")}
        >
          Account & routing number
        </button>
      </div>
    </div>
  );
};

export default RecipientTypeSelector;